import messages from './messages';

export const TIME_BREAKDOWN_OPTIONS = {
	hourly: 'h',
	daily: 'd',
	weekly: 'w',
	monthly: 'm',
} as const;

export const DROPDOWN_OPTIONS = [
	{
		id: TIME_BREAKDOWN_OPTIONS.hourly,
		message: messages.hourly,
	},
	{
		id: TIME_BREAKDOWN_OPTIONS.daily,
		message: messages.daily,
	},
	{
		id: TIME_BREAKDOWN_OPTIONS.weekly,
		message: messages.weekly,
	},
	{
		id: TIME_BREAKDOWN_OPTIONS.monthly,
		message: messages.monthly,
	},
] as const;

export const DATE_FORMAT = 'YYYY-MM-DD';
